var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisibilitySensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 659,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-876 -659)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 876,
    y: 659,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289 1691.5C1289 1343.28 1571.28 1061 1919.5 1061 2267.72 1061 2550 1343.28 2550 1691.5 2550 2039.72 2267.72 2322 1919.5 2322 1571.28 2322 1289 2039.72 1289 1691.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1134,
    y: 906,
    width: 1571,
    height: 1571,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1824.5 759.5 1604.5 1116.5 1384.5 759.5Z",
    stroke: "#000000",
    strokeWidth: 17.1875,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#3865B6",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilitySensor);
export default __webpack_public_path__ + "static/media/VisibilitySensor.499786555b1bd54d00f330b205b85f2e.svg";
export { ForwardRef as ReactComponent };